<template>
  <div class="project_alternatives">
    <div class="project_alternatives_context">
      <!-- 标题 -->
      <div class="project_alternatives_context_title">项目寻访方案</div>
      <!-- 主体 -->
      <div class="project_alternatives_context_main">
        <el-form :model="form" class="demo-ruleForm" ref="form" :rules="rules" label-width="120px">
          <!-- 项目背景 -->
          <div class="project_background">
            <h2 class="title">项目背景</h2>
            <div class="background_main">
              <div class="background_main_left">
                <el-form-item label="项目经理 :">
                  <el-input :readonly="true" v-model="form.projectManager"></el-input>
                </el-form-item>

                <el-form-item label="公司 :">
                  <el-input :readonly="true" v-model="form.corporateName"></el-input>
                </el-form-item>

                <el-form-item label="岗位 :">
                  <el-input :readonly="true" v-model="form.post"></el-input>
                </el-form-item>

                <el-form-item label="地点 :">
                  <el-input :readonly="true" v-model="form.dutyStation"></el-input>
                </el-form-item>

                <el-form-item label="薪资范围 :">
                  <el-input :readonly="true" v-model="form.salaryRange"></el-input>
                </el-form-item>
              </div>
              <div class="background_main_right">
                <el-form-item label="客户经理 :">
                  <el-input :readonly="true" v-model="form.customerManager"></el-input>
                </el-form-item>
                <el-form-item label="启动日期 :">
                  <el-input :readonly="true" v-model="form.startTime"></el-input>
                </el-form-item>
                <el-form-item label="上传日期 :">
                  <el-input :readonly="true" v-model="form.createTime"></el-input>
                </el-form-item>
                <el-form-item label="确认时间 :">
                  <el-input :readonly="true" v-model="form.affirmTime"></el-input>
                </el-form-item>
                <el-form-item label="预计首推 :">
                  <el-input v-model="form.predictPush"></el-input>
                </el-form-item>
              </div>
            </div>
          </div>
          <!-- 公司亮点 -->
          <div class="lightSpot">
            <h2 class="title">
              <span>公司亮点</span>
              <span style="font-size: 14px; font-weight: 400; margin-left: 4px; color: #666666"
                >【包括但不限于下列事项】</span
              >
            </h2>
            <div class="lightSpot_main">
              <el-form-item label="赛道前景 :">
                <el-input
                  :readonly="readonly"
                  v-model="form.trackProspect"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  type="textarea"
                ></el-input>
              </el-form-item>

              <el-form-item label="行业地位 :">
                <el-input
                  :readonly="readonly"
                  v-model="form.positionIndustry"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  type="textarea"
                ></el-input>
              </el-form-item>

              <el-form-item label="管理团队 :">
                <el-input
                  :readonly="readonly"
                  v-model="form.managementTeam"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  type="textarea"
                ></el-input>
              </el-form-item>

              <el-form-item label="技术优势 :">
                <el-input
                  :readonly="readonly"
                  v-model="form.technologicalSuperiority"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  type="textarea"
                ></el-input>
              </el-form-item>

              <el-form-item label="产品优势 :">
                <el-input
                  :readonly="readonly"
                  v-model="form.productSuperiority"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  type="textarea"
                ></el-input>
              </el-form-item>

              <el-form-item label="营收能力 :">
                <el-input
                  :readonly="readonly"
                  v-model="form.salesAbility"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  type="textarea"
                ></el-input>
              </el-form-item>

              <el-form-item label="资本实力 :">
                <el-input
                  :readonly="readonly"
                  v-model="form.capitalStrength"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  type="textarea"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="其他 :"
                v-for="(item, index) in form.companyRestsList"
                :key="index"
              >
                <el-input
                  :readonly="readonly"
                  v-model="form.companyRestsList[index]"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  type="textarea"
                ></el-input>
                <!-- 添加 -->
                <div class="add" @click="clickAddCompanyRestsItem">
                  <i class="add_icon el-icon-circle-plus-outline"></i>添加
                </div>

                <!-- 删除 -->
                <div v-if="index >= 1" class="remove" @click="clickRemoveCompanyRestsItem(index)">
                  <i class="remove_icon el-icon-delete"></i>删除
                </div>
              </el-form-item>
            </div>
          </div>
          <!-- 公司介绍话术 -->
          <div class="recommend">
            <h2 class="title">
              <span>公司介绍话术</span>
              <span style="font-size: 14px; font-weight: 400; margin-left: 4px; color: #666666"
                >【需包含公司亮点】</span
              >
            </h2>

            <div class="recommend_main">
              <el-form-item
                label-width="82px"
                v-for="(item, index) in form.introduceVerbalTricks"
                :key="index"
              >
                <el-input
                  :readonly="readonly"
                  v-model="form.introduceVerbalTricks[index]"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 6 }"
                ></el-input>
                <!-- 添加 -->
                <div class="add" @click="clickAddIntroduceVerbalTricksItem">
                  <i class="add_icon el-icon-circle-plus-outline"></i>添加
                </div>

                <!-- 删除 -->
                <div
                  v-if="index >= 1"
                  class="remove"
                  @click="clickRemoveIntroduceVerbalTricksItem(index)"
                >
                  <i class="remove_icon el-icon-delete"></i>删除
                </div>
              </el-form-item>
            </div>
          </div>
          <!-- 岗位职责 -->
          <div class="responsibility">
            <h2 class="title">
              <span>岗位职责</span>
              <span style="font-size: 14px; font-weight: 400; margin-left: 4px; color: #666666"
                >【尽量精简；按重要性排序；可自主增减】</span
              >
            </h2>
            <div class="responsibility_main">
              <el-form-item
                label-width="82px"
                v-for="(item, index) in form.postResponsibilityList"
                :key="index"
              >
                <el-input
                  :readonly="readonly"
                  v-model="form.postResponsibilityList[index]"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                >
                </el-input>
                <div class="serial_number">{{ index + 1 }}.</div>
                <!-- 添加 -->
                <div class="add" @click="clickAddPostResponsibilityItem">
                  <i class="add_icon el-icon-circle-plus-outline"></i>添加
                </div>
                <!-- 删除 -->
                <div
                  v-if="index >= 1"
                  class="remove"
                  @click="clickRemovePostResponsibilityItem(index)"
                >
                  <i class="remove_icon el-icon-delete"></i>删除
                </div>
              </el-form-item>
            </div>
          </div>
          <!-- 岗位要求 -->
          <div class="postRequires">
            <h2 class="title">
              <span>岗位要求</span>
              <span style="font-size: 14px; font-weight: 400; margin-left: 4px; color: #666666"
                >【尽量精简；按重要性排序；可自主增减】</span
              >
            </h2>

            <div class="postRequires_main">
              <el-form-item
                label-width="82px"
                v-for="(item, index) in form.postRequires"
                :key="index"
              >
                <el-input
                  :readonly="readonly"
                  v-model="form.postRequires[index]"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                ></el-input>
                <!-- 添加 -->
                <div class="add" @click="clickAddPostRequiresItem">
                  <i class="add_icon el-icon-circle-plus-outline"></i>添加
                </div>

                <!-- 删除 -->
                <div v-if="index >= 1" class="remove" @click="clickRemovePostRequiresItem(index)">
                  <i class="remove_icon el-icon-delete"></i>删除
                </div>
              </el-form-item>
            </div>
          </div>
          <!-- 岗位亮点  -->
          <div class="lightSpot">
            <h2 class="title">
              <span>岗位亮点 </span>
              <span style="font-size: 14px; font-weight: 400; margin-left: 4px; color: #666666"
                >【包括但不限于下列事项】</span
              >
            </h2>
            <div class="lightSpot_main">
              <el-form-item label="项目内容 :">
                <el-input
                  :readonly="readonly"
                  v-model="form.projectContent"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                ></el-input>
              </el-form-item>
              <el-form-item label="团队架构 :">
                <el-input
                  :readonly="readonly"
                  v-model="form.teamStructure"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                ></el-input>
              </el-form-item>
              <el-form-item label="工作权限 :">
                <el-input
                  :readonly="readonly"
                  v-model="form.workPermissions"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                ></el-input>
              </el-form-item>
              <el-form-item label="晋升空间 :">
                <el-input
                  :readonly="readonly"
                  v-model="form.promoteInterspace"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                ></el-input>
              </el-form-item>
              <el-form-item label="福利待遇 :">
                <el-input
                  :readonly="readonly"
                  v-model="form.socialBenefits"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                ></el-input>
              </el-form-item>
              <el-form-item label="其他 :" v-for="(item, index) in form.postRestsList" :key="index">
                <el-input
                  :readonly="readonly"
                  v-model="form.postRestsList[index]"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                ></el-input>
                <!-- 添加 -->
                <div class="add" @click="clickAddPostRestsItem">
                  <i class="add_icon el-icon-circle-plus-outline"></i>添加
                </div>
                <!-- 删除 -->
                <div v-if="index >= 1" class="remove" @click="clickRemovePostRestsItem(index)">
                  <i class="remove_icon el-icon-delete"></i>删除
                </div>
              </el-form-item>
            </div>
          </div>
          <!-- 岗位介绍话术 -->
          <div class="verbal_trick">
            <h2 class="title">
              <span>岗位介绍话术 </span>
              <span style="font-size: 14px; font-weight: 400; margin-left: 4px; color: #666666"
                >【需包含岗位亮点】</span
              >
            </h2>
            <div class="verbal_trick_main">
              <el-form-item label-width="70px">
                <el-input
                  :readonly="readonly"
                  v-model="form.postVerbalTrick"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <!-- 岗位介绍话术 -->
          <div class="benchmarking">
            <h2 class="title">
              <span>行业对标公司 </span>
              <span class="mini_font"> 【列出5家以上】 </span>
            </h2>
            <div class="benchmarking_main">
              <el-form-item
                label-width="70px"
                v-for="(item, index) in form.postBenchmarkingCompanyList"
                :key="index"
              >
                <el-input
                  :readonly="readonly"
                  v-model="form.postBenchmarkingCompanyList[index]"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <!-- 添加 -->
              <div class="add" @click="clickAddPostBenchmarkingCompanyList">
                <i class="add_icon el-icon-circle-plus-outline"></i>添加
              </div>

              <!-- 删除 -->
              <!-- <div class="remove"><i class="remove_icon el-icon-delete"></i>删除</div> -->
            </div>
          </div>

          <div class="benchmarking">
            <h2 class="title">
              <span>其他可能行业 </span>
              <span class="mini_font">【列出5家以上】</span>
            </h2>
            <div class="benchmarking_main">
              <el-form-item
                label-width="70px"
                v-for="(item, index) in form.benchmarkingCompanyList"
                :key="index"
              >
                <el-input
                  :readonly="readonly"
                  v-model="form.benchmarkingCompanyList[index]"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <!-- 添加 -->
              <div class="add" @click="clickAddBenchmarking">
                <i class="add_icon el-icon-circle-plus-outline"></i>添加
              </div>

              <!-- 删除 -->
              <!-- <div class="remove"><i class="remove_icon el-icon-delete"></i>删除</div> -->
            </div>
          </div>

          <!-- 关键词 -->
          <div class="twoWordVo">
            <h2 class="title">
              <span>关键词 </span>
              <span style="font-size: 14px; font-weight: 400; margin-left: 4px; color: #666666"
                >【按重要性排序；替换词尽量多写；可自主增减】</span
              >
            </h2>
            <div class="twoWordVo_main">
              <div class="twoWordVo_main_box" v-for="(item, index) in form.twoWordVo" :key="index">
                <el-form-item label-width="70px">
                  <el-input :readonly="readonly" v-model="item.keyword"></el-input>
                </el-form-item>
                <el-form-item label-width="70px" label="替换词 :">
                  <el-input :readonly="readonly" v-model="item.replace"></el-input>
                </el-form-item>
                <!-- 添加 -->
                <div class="add" @click="clickAddTwoWordVoItem">
                  <i class="add_icon el-icon-circle-plus-outline"></i>添加
                </div>
                <!-- 删除 -->
                <div v-if="index >= 1" class="remove" @click="clickRemoveTwoWordVoItem(index)">
                  <i class="remove_icon el-icon-delete"></i>删除
                </div>
              </div>
            </div>
          </div>

          <!-- 筛选条件 -->
          <div class="screen_condition">
            <h2 class="title">
              <span>筛选条件</span>
              <span style="font-size: 14px; font-weight: 400; margin-left: 4px; color: #666666"
                >【关键词搜索结果过多，可用于收窄范围】</span
              >
            </h2>
            <div class="screen_condition_main">
              <div class="screen_condition_main_left">
                <el-form-item label="地点 :">
                  <el-input :readonly="readonly" v-model="form.place"></el-input>
                </el-form-item>

                <el-form-item label="工作年限 :">
                  <el-input :readonly="readonly" v-model="form.yearsWorking"></el-input>
                </el-form-item>

                <el-form-item label="其他 :">
                  <el-input :readonly="readonly" v-model="form.screenRests"></el-input>
                </el-form-item>
              </div>
              <div class="screen_condition_main_right">
                <el-form-item label="学历 :">
                  <el-input :readonly="readonly" v-model="form.educationBackground"></el-input>
                </el-form-item>

                <el-form-item label="年龄 :">
                  <el-input :readonly="readonly" v-model="form.age"></el-input>
                </el-form-item>
              </div>
            </div>
          </div>

          <!-- 疑问 -->
          <div class="doubt">
            <h2 class="title">
              <span>疑问</span>
              <span style="font-size: 14px; font-weight: 400; margin-left: 4px; color: #666666"
                >【面向客户或部门经理的问题】</span
              >
            </h2>
            <div class="doubt_main">
              <el-form-item label-width="70px" v-for="(item, index) in form.queryList" :key="index">
                <el-input
                  :readonly="readonly"
                  v-model="form.queryList[index]"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                ></el-input>

                <!-- 添加 -->
                <div class="add" @click="clickAddQueryItem">
                  <i class="add_icon el-icon-circle-plus-outline"></i>添加
                </div>

                <!-- 删除 -->
                <div v-if="index >= 1" class="remove" @click="clickRemoveQueryItem(index)">
                  <i class="remove_icon el-icon-delete"></i>删除
                </div>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <!-- 操作按钮 -->
    <div class="options_button">
      <!--  // 职位0->部门经理；1->客户经理；2->项目经理；3->商务经理
        sessionStorage.setItem('position', res.data.data.position) -->
      <div
        class="confirm"
        @click="clickSend"
        v-if="(sent == false && position == 1) || position == 2"
      >
        确认发送
      </div>
      <div class="success" v-if="sent">已发送</div>
      <div class="confirm" @click="clickConfirm" v-if="acknowledged == false && position == 0">
        确认
      </div>
      <div class="success" v-if="acknowledged">已确认</div>
      <div class="confirm" @click="clickKeep">保存</div>
      <div class="back" @click="clickBack">返回上级</div>
      <div class="derive" @click="clickDerive">导出寻访方案</div>
    </div>
  </div>
</template>
<script>
import { getSearch, saveSearch, saveMessage, projectLookFor } from '@/api/projectCenter'
const defaultQueryInfo = Object.freeze({
  baseParam: {
    pageNum: 1,
    pageSize: 10
  },
  id: 0, // 	寻访方案id
  order: 'asc', // 默认为null。排序：desc，asc
  projectId: 0 //  项目id
})
export default {
  components: {},
  data() {
    return {
      // 请求基本数据
      queryInfo: { ...defaultQueryInfo },
      form: {
        affirmTime: null, // 确认时间
        age: '', // 年龄（筛选条件）
        benchmarkingCompany: '', // 对标公司（逗号隔开）
        benchmarkingCompanyList: ['', '', '', '', ''], // 对标公司（逗号隔开）集合
        postBenchmarkingCompanyList: ['', '', '', '', ''],
        postBenchmarkingCompany: '',
        capitalStrength: '', // 资本实力
        companyRests: '', // （公司亮点）其他
        companyRestsList: [''], // （公司亮点）其他集合
        corporateName: '',
        createName: '', // 创建人名字
        createTime: null, // 创建时间即上传时间
        customerManager: '', // 客户经理
        dutyStation: '', // 工作地点
        educationBackground: '', // 学历（筛选条件）
        id: 0, // 主键
        introduceVerbalTrick: '', // 公司介绍话术
        introduceVerbalTricks: [''], // 公司介绍话术集合
        isAnnual: 0, // 月薪或者年薪0->月薪；1->年薪
        keyword: '', // 关键词（逗号隔开）
        orderSize: '', // 序号
        // 关键词
        twoWordVo: [
          {
            // 关键词
            keyword: '',
            // 替换词
            replace: ''
          }
        ],
        managementTeam: '', // 管理团队
        place: '', // 地点（筛选条件）
        positionIndustry: '', // 行业地位
        postRequire: '', // 岗位要求
        postRequires: [''], // 岗位要求集合
        postResponsibility: '', // 岗位职责
        postResponsibilityList: [''], // 岗位职责集合
        postRests: '', //  （岗位亮点）其他
        postRestsList: [''], //  （岗位亮点）其他集合
        postVerbalTrick: '', // 岗位介绍话术
        predictPush: '', // 预计首推
        productSuperiority: '', // 产品优势
        projectContent: '', // 项目内容
        projectId: 0, //  项目ID
        projectManager: '', // 项目经理
        promoteInterspace: '', // 晋升空间
        querys: '', // 疑问
        queryList: [''], // 疑问集合
        replaces: '', // 替换词
        post: '', // 招聘职位
        salaryRange: '', // 薪资范围
        salesAbility: '', // 营收能力
        screenRests: '', // 其他（筛选条件）
        socialBenefits: '', //福利待遇
        startTime: null, // 启动时间
        teamStructure: '', // 团队架构
        technologicalSuperiority: '', // 技术优势
        trackProspect: '', // 赛道前景
        updateName: '', // 修改人名字
        updateTime: '', // 修改时间
        workPermissions: '', // 工作权限
        yearsWorking: '' // 工作年限（筛选条件）
      },

      rules: {
        name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }]
      },
      // 已发送按钮状态
      sent: false,
      // 已确认按钮状态
      acknowledged: false,
      readonly: false
    }
  },
  computed: {
    // 项目ID
    projectId() {
      return this.$route.query.projectId ? this.$route.query.projectId * 1 : ''
    },
    // 寻访方案id  用来回显
    id() {
      return this.$route.query.id ? this.$route.query.id * 1 : 0
    },
    position() {
      return sessionStorage.getItem('position')
    },
    tr() {
      return this.$route.query.tr ? true : false
    },
    item() {
      return JSON.parse(this.$route.query.item)
    },
    oneNew() {
      return this.$route.query.oneNew
    }
  },
  created() {
    this.readonly = this.tr
    this.search()
    // console.log(this.item);
  },
  watch: {},
  methods: {
    async search() {
      this.queryInfo.projectId = this.projectId
      console.log(this.oneNew)
      if (this.oneNew) {
        this.queryInfo.id = null
      } else {
        this.queryInfo.id = this.id
      }

      const { data: res } = await getSearch(this.queryInfo)
      if (res.resultCode == 200) {
        if (res.data.list[0]) {
          this.form = res.data.list[0]
          // this.form.corporateName = this.item.corporateName
          // this.form.customerManager = this.item.customerManager
          // this.form.projectManager = this.item.projectManager
          this.form.post = this.item.recruitmentPosition
          if (
            this.form.postBenchmarkingCompanyList == null ||
            !this.form.postBenchmarkingCompanyList[0]
          ) {
            this.form.postBenchmarkingCompanyList = ['', '', '', '', '']
          }
          if (this.form.companyRestsList == null || this.form.companyRestsList.length == 0) {
            this.form.companyRestsList = ['']
          }
          if (
            this.form.introduceVerbalTricks == null ||
            this.form.introduceVerbalTricks.length == 0
          ) {
            this.form.introduceVerbalTricks = ['']
          }
          if (
            this.form.postResponsibilityList == null ||
            this.form.postResponsibilityList.length == 0
          ) {
            this.form.postResponsibilityList = ['']
          }
          if (this.form.postRequires == null || this.form.postRequires.length == 0) {
            this.form.postResponsibilityList = ['']
          }
          if (
            this.form.benchmarkingCompanyList == null ||
            this.form.benchmarkingCompanyList.length == 0
          ) {
            this.form.benchmarkingCompanyList = [' ', ' ', ' ', ' ', ' ']
          }
          if (this.form.queryList == null || this.form.queryList.length == 0) {
            this.form.queryList = ['']
          }
          if (this.form.twoWordVo == null) {
            this.form.twoWordVo = [
              {
                // 关键词
                keyword: '',
                // 替换词
                replace: ''
              }
            ]
          }
          if (this.form.postRequires == null || this.form.postRequires.length == 0) {
            this.form.postRequires = [''] // 岗位要求集合
          }

          if (this.form.postRestsList == null || this.form.postRestsList.length == 0) {
            this.form.postRestsList = [''] // 岗位要求集合
          }
        } else {
          this.form = {
            affirmTime: null, // 确认时间
            age: '', // 年龄（筛选条件）
            benchmarkingCompany: '', // 对标公司（逗号隔开）
            // 岗位对标公司（逗号隔开）集合
            benchmarkingCompanyList: ['1', '2', '3', '4', '5'],
            //行业对标公司（逗号隔开）集合
            postBenchmarkingCompanyList: ['1', '2', '3', '4', '5'],
            postBenchmarkingCompany: '',
            capitalStrength: '', // 资本实力
            companyRests: '', // （公司亮点）其他
            companyRestsList: [''], // （公司亮点）其他集合
            corporateName: this.item.corporateName,
            createName: '', // 创建人名字
            createTime: null, // 创建时间即上传时间
            customerManager: this.item.customerManager, // 客户经理
            dutyStation: '', // 工作地点
            educationBackground: '', // 学历（筛选条件）
            id: 0, // 主键
            introduceVerbalTrick: '', // 公司介绍话术
            introduceVerbalTricks: [''], // 公司介绍话术集合
            isAnnual: 0, // 月薪或者年薪0->月薪；1->年薪
            keyword: '', // 关键词（逗号隔开）
            orderSize: '0', // 序号
            // 关键词
            twoWordVo: [
              {
                // 关键词
                keyword: '',
                // 替换词
                replace: ''
              }
            ],
            managementTeam: '', // 管理团队
            place: '', // 地点（筛选条件）
            positionIndustry: '', // 行业地位
            postRequire: '', // 岗位要求
            postRequires: [''], // 岗位要求集合
            postResponsibility: '', // 岗位职责
            postResponsibilityList: [''], // 岗位职责集合
            postRests: '', //  （岗位亮点）其他
            postRestsList: [''], //  （岗位亮点）其他集合
            postVerbalTrick: '', // 岗位介绍话术
            predictPush: this.item.predictPush, // 预计首推
            productSuperiority: '', // 产品优势
            projectContent: '', // 项目内容
            projectId: 0, //  项目ID
            projectManager: this.item.projectManager, // 项目经理
            promoteInterspace: '', // 晋升空间
            querys: '', // 疑问
            queryList: [''], // 疑问集合
            replaces: '', // 替换词
            post: this.item.recruitmentPosition, // 招聘职位
            salaryRange: '', // 薪资范围
            salesAbility: '', // 营收能力
            screenRests: '', // 其他（筛选条件）
            socialBenefits: '', //福利待遇
            startTime: null, // 启动时间
            teamStructure: '', // 团队架构
            technologicalSuperiority: '', // 技术优势
            trackProspect: '', // 赛道前景
            updateName: '', // 修改人名字
            updateTime: '', // 修改时间
            workPermissions: '', // 工作权限
            yearsWorking: '' // 工作年限（筛选条件）
          }
        }
      }
    },
    // 公司亮点  添加这一项
    clickAddCompanyRestsItem() {
      if (this.readonly) {
        return
      }
      this.form.companyRestsList.push('')
    },
    // 公司亮点  移除这一项
    clickRemoveCompanyRestsItem(index) {
      if (this.readonly) {
        return
      }
      this.form.companyRestsList.splice(index, 1)
    },

    // 公司介绍话术  添加这一项
    clickAddIntroduceVerbalTricksItem() {
      if (this.readonly) {
        return
      }
      this.form.introduceVerbalTricks.push('')
    },
    // 公司介绍话术  移除这一项
    clickRemoveIntroduceVerbalTricksItem(index) {
      if (this.readonly) {
        return
      }
      this.form.introduceVerbalTricks.splice(index, 1)
    },

    // 公司岗位职责  添加这一项
    clickAddPostResponsibilityItem() {
      if (this.readonly) {
        return
      }
      this.form.postResponsibilityList.push('')
    },
    // 公司岗位职责  移除这一项
    clickRemovePostResponsibilityItem(index) {
      if (this.readonly) {
        return
      }
      this.form.postResponsibilityList.splice(index, 1)
    },

    // 岗位  添加这一项
    clickAddPostRestsItem() {
      if (this.readonly) {
        return
      }
      this.form.postRestsList.push('')
    },
    // 公司亮点  移除这一项
    clickRemovePostRestsItem(index) {
      if (this.readonly) {
        return
      }
      this.form.postRestsList.splice(index, 1)
    },

    // 岗位要求  添加这一项
    clickAddPostRequiresItem() {
      if (this.readonly) {
        return
      }
      this.form.postRequires.push('')
    },
    // 岗位要求  移除这一项
    clickRemovePostRequiresItem(index) {
      if (this.readonly) {
        return
      }
      this.form.postRequires.splice(index, 1)
    },
    // 添加 岗位介绍话术
    clickAddBenchmarking() {
      if (this.readonly) {
        return
      }
      this.form.benchmarkingCompanyList.push(' ')
    },
    clickAddPostBenchmarkingCompanyList() {
      if (this.readonly) {
        return
      }
      this.form.postBenchmarkingCompanyList.push(' ')
    },
    // 关键词 添加这一项
    clickAddTwoWordVoItem() {
      if (this.readonly) {
        return
      }
      this.form.twoWordVo.push({
        keyword: '',
        replace: ''
      })
    },
    // 关键词 移除这一项
    clickRemoveTwoWordVoItem(index) {
      if (this.readonly) {
        return
      }
      this.form.twoWordVo.splice(index, 1)
    },

    // 疑问  添加这一项
    clickAddQueryItem() {
      if (this.readonly) {
        return
      }
      this.form.queryList.push('')
    },
    // 疑问  移除这一项
    clickRemoveQueryItem(index) {
      if (this.readonly) {
        return
      }
      this.form.queryList.splice(index, 1)
    },

    // 发送确认按钮
    async clickSend() {
      if (this.readonly) {
        return
      }
      this.sent = true
      this.form.affirmTime = this.initDay()
      let query = {
        createName: '',
        createTime: '',
        englishName: '',
        id: 0,
        isNew: 1,
        jumpPath: this.$route.fullPath,
        messageContent: ''
      }
      const { data: res } = await saveMessage(query)
    },
    // 确认按钮
    clickConfirm() {
      if (this.readonly) {
        return
      }
      this.acknowledged = true
      this.form.affirmTime = this.initDay()
      // console.log(this.form.createTime);
    },
    initDay() {
      const date = new Date() // 得到当前时间

      const year = date.getFullYear() // 年
      const mont = date.getMonth() + 1 // 月
      const dat = date.getDate() // 日
      const hour = date.getHours() // 时
      const minute = date.getMinutes() // 分
      const second = date.getSeconds() // 秒

      const hours = hour < 10 || hour === 0 ? '0' + hour : hour // 时
      const minutes = minute < 10 ? '0' + minute : minute // 分
      const seconds = second < 10 ? '0' + second : second // 秒
      return `${year}-${mont}-${dat} ${hours}:${minutes}:${seconds}`
    },
    // 保存按钮
    async clickKeep() {
      if (this.readonly) {
        return
      }
      this.form.yearsWorking = this.form.yearsWorking * 1
      this.form.age = this.form.age * 1
      this.form.projectId = this.projectId
      this.form.benchmarkingCompany = ''
      let str = ''
      str = this.form.orderSize * 1
      this.form.orderSize = str + 0.1
      this.form.orderSize = this.form.orderSize.toFixed(1) + ''
      const { data: res } = await saveSearch(this.form)
      console.log(res)
      if (res.resultCode == 200) {
        this.$message.success('保存成功')
        let time = null
        time = setTimeout(() => {
          this.$router.go(-1)
          clearTimeout(time)
          time = null
        }, 1000)
      }
    },

    // 返回上级按钮
    clickBack() {
      this.$router.go(-1)
    },
    // 导出寻访方案按钮
    async clickDerive() {
      this.clickKeep().then(async () => {
        let id = this.form.id
        const { data: res } = await projectLookFor({
          id
        })
        if (res) {
          let blob = new Blob([res])
          let href = window.URL.createObjectURL(blob) //创建新的URL表示指定的blob对象
          const a = document.createElement('a') //创建a标签
          a.style.display = 'none'
          a.href = href // 指定下载'链接
          a.download = `寻访方案v${this.form.orderSize}.pdf` //指定下载文件名
          // a.download = "test.png";
          a.click() //触发下载
          window.URL.revokeObjectURL(a.href) //释放URL对象
          if (document.body.contains(a)) {
            document.body.removeChild(a) //释放标签
          }
          // else {
          //   this.$message.error('导出失败!')
          // }
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.project_alternatives {
  display: flex;
  justify-content: center;
  position: relative;
  /* height: auto !important; */
}
.project_alternatives /deep/.el-textarea {
  width: 80%;
}
.project_alternatives /deep/.el-textarea__inner {
  height: 40px;
}
.project_alternatives_context {
  width: 90%;
  background-color: #fff;
}
.project_alternatives_context_title {
  font-size: 24px;
  font-weight: 600;
  color: #333333;
  text-align: center;
  padding-top: 24px;
  margin-bottom: 41px;
}
.project_alternatives_context_main {
  height: 64vh;
  overflow-y: auto;
  padding: 0 5%;
  box-sizing: border-box;
  background-color: #fff;
}
.project_background {
  .title {
    color: #333333;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 24px;
  }
}
.background_main {
  display: flex;
  justify-content: space-between;
  /deep/ .el-form-item__content {
    display: flex;
  }
  /deep/ .el-input__inner {
    cursor: auto;
  }
  /deep/ .el-input {
    width: 298px;
    height: 32px;
    line-height: 32px;
  }
  /deep/ .el-form-item {
    margin-bottom: 16px;
  }
}
.lightSpot {
  margin-top: 24px;
  .title {
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 20px;
  }
}
.lightSpot_main {
  /deep/.el-form-item__content {
    display: flex;
    align-items: center;
  }
}
.recommend {
  margin-top: 24px;
  .title {
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 20px;
  }
}
.recommend_main {
  /deep/.el-form-item__content {
    display: flex;
    align-items: center;
  }
}
.responsibility {
  margin-top: 24px;
  .title {
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 20px;
  }
}
.responsibility_main {
  position: relative;
  .serial_number {
    position: absolute;
    color: #857979;
    left: -20px;
  }
  /deep/.el-form-item__content {
    display: flex;
    align-items: center;
  }
}
.postRequires {
  margin-top: 24px;
  .title {
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 20px;
  }
}
.postRequires_main {
  /deep/.el-form-item__content {
    display: flex;
    align-items: center;
  }
}
.verbal_trick {
  margin-top: 24px;
  .title {
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 20px;
  }
}
.verbal_trick_main {
  /deep/.el-textarea__inner {
    height: 93px;
  }
  /deep/.el-form-item__content {
    display: flex;
    align-items: center;
  }
}
.benchmarking {
  margin-top: 24px;
  .title {
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 20px;
  }
}
.benchmarking_main {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-height: 200px;
  /deep/.el-input {
    width: 300px;
    height: 40px;
    line-height: 40px;
  }
  /deep/.el-form-item {
    margin-bottom: 9px;
  }
}
.doubt {
  margin-top: 24px;
  .title {
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 20px;
  }
}
.doubt_main {
  /deep/.el-form-item__content {
    display: flex;
    align-items: center;
  }
}
.screen_condition {
  margin-top: 24px;
  .title {
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 20px;
  }
}
.screen_condition_main {
  display: flex;

  /deep/.el-form-item__content {
    display: flex;
  }
  /deep/.el-input {
    width: 300px;
  }
  /deep/.el-form-item {
    margin-bottom: 16px;
  }
}

.twoWordVo {
  margin-top: 24px;
  .title {
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 20px;
  }
}
.twoWordVo_main_box {
  display: flex;
  align-items: center;
  /deep/.el-form-item {
    margin-bottom: 10px;
  }
  /deep/.el-form-item__content {
    display: flex;
    margin-left: 0;
  }
  /deep/.el-input {
    width: 300px;
  }
  /* /deep/.el-form-item {
    margin-bottom: 10px;
  }
  /deep/.el-form-item__content {
    display: flex;
  }
  /deep/.el-input {
    width: 356px;
  } */
}
.options_button {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;

  display: flex;
  margin-top: 50px;
  justify-content: center;
  align-items: center;
  position: absolute;
  height: 72px;
  left: 0;
  bottom: -10px;
  background: #fff;
  width: 100%;
  box-shadow: 0px 0px 4px 0px #00000040;
  .success {
    width: 88px;
    height: 36px;
    background-color: #efefef;
    border-radius: 4px;
    color: #999999;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 18px;
    cursor: pointer;
  }

  .confirm {
    width: 88px;
    height: 36px;
    background-color: #17757a;
    border-radius: 4px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 18px;
    cursor: pointer;
  }

  .back {
    width: 88px;
    height: 36px;
    background-color: #fff;
    border-radius: 4px;
    color: #17757a;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #17757a;
    margin-right: 18px;
    cursor: pointer;
  }

  .derive {
    width: 104px;
    height: 36px;
    background-color: #2a70b0;
    border-radius: 4px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-right: 18px;
  }
}

.add {
  color: #17757a;
  margin-right: 15px;
  line-height: 0;
  margin-left: 20px;
  cursor: pointer;
  .add_icon {
    font-size: 17px;
    margin-right: 8px;
  }
}
.remove {
  color: #f45454;
  line-height: 0;
  cursor: pointer;
  .remove_icon {
    font-size: 17px;
    color: #f45454;
  }
}

.mini_font {
  font-size: 14px;
  font-weight: 400;
  margin-left: 4px;
  color: #666666;
}

/* 媒体查询：自适应 */
// 1680x1050 (1680x889)
@media (max-width: 1682px) and (max-height: 890px) {
  .options_button {
    bottom: 14px !important;
  }
}

// 1600x900 (1600x739)
@media (max-width: 1602px) and (max-height: 740px) {
  .options_button {
    bottom: 164px !important;
  }
  .project_alternatives_context_main {
    padding-bottom: 40px !important;
  }
}

// 1366x768 (1366x607)
@media (max-width: 1368px) and (max-height: 608px) {
  .options_button {
    bottom: 296px !important;
  }
  .project_alternatives_context_main {
    padding-bottom: 60px !important;
  }
}

// 1280x1024 (1280x863)
@media (max-width: 1282px) and (max-height: 864px) {
  .options_button {
    bottom: 40px !important;
  }
}

// 1280x960 (1280x799)
@media (max-width: 1282px) and (max-height: 800px) {
  .options_button {
    bottom: 106px !important;
  }
}

// 1280x800 (1280x639)
@media (max-width: 1282px) and (max-height: 640px) {
  .options_button {
    bottom: 262px !important;
  }
}

// 1280x768 (1280x607)
@media (max-width: 1282px) and (max-height: 608px) {
  .options_button {
    bottom: 296px !important;
  }
}

// 1280x720 (1280x599)
@media (max-width: 1282px) and (max-height: 600px) {
  .options_button {
    bottom: 342px !important;
  }
  .project_alternatives_context_main {
    padding-bottom: 80px !important;
  }
}

// 1280x600 (1280x439)
@media (max-width: 1282px) and (max-height: 440px) {
  .options_button {
    bottom: 464px !important;
  }
  .project_alternatives_context_main {
    padding-bottom: 130px !important;
  }
}

// 1152x864 (1152x703)
@media (max-width: 1153px) and (max-height: 704px) {
  .options_button {
    bottom: 198px !important;
  }
}

// 1024x768 (1024x607)
@media (max-width: 1025px) and (max-height: 608px) {
  .options_button {
    bottom: 294px !important;
  }
}

// 800x600 (800x439)
@media (max-width: 801px) and (max-height: 440px) {
  .options_button {
    bottom: 462px !important;
  }
}
</style>
